export const API_DEV = 'https://apiedumet.neomeisters.com/ci4/api';
export const API_PROD = 'https://admin.edumet.net/ci4/api';
export const API = 'http://192.168.9.71:8080/api/';

export default {
    API_ENDPOINT: API_PROD,
};
